import React from 'react';
import { Route, IndexRoute } from 'react-router';
import { withProps } from 'recompose';
import camelize from 'camelize';
import PromotionGroupContainer from '../Promotion/PromotionGroupContainer';
import { fetchPromotionGroup } from '../Common/Providers/PromotionGroupApi';

const fetchPromotionGroupComponent = (location, callback) => {
  fetchPromotionGroup(location.params.splat)
    .done((response) => {
      const { timestamp } = response.meta;
      callback(null, withProps(camelize({ ...response.data, timestamp }))(PromotionGroupContainer));
    })
    .fail(() => {
      window.location = '/invalid-promotions';
    });
};

const PromotionGroupRoute = (
  <Route label="Prepaid"
    helmet={{
      title: 'Prepaid',
      metaDescription: 'The Right Deals and Discounts by {storeName}',
    }}
    path="/(:id/)(prp)(promotions/promo)/*"
    getComponent={fetchPromotionGroupComponent}
  >
    <IndexRoute>
    </IndexRoute>
  </Route>
);

export default PromotionGroupRoute;



// WEBPACK FOOTER //
// ./src/Routes/PromotionGroup.js